import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FeeComponentProps, TPayPageFeesDisclaimers } from '../../types';
import { mapPayPageFeeData } from '../../utils';
import { useDataContext } from '../../context/dataContainer';

type PayPageFeeProps = Pick<FeeComponentProps, 'paymentType' | 'currentLanguage'>;

export const PayPageFee = ({ paymentType, currentLanguage = 'en' }: PayPageFeeProps) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('feesPayPage');
  const { feesDisclaimers } = useDataContext();

  const feeNF = new Intl.NumberFormat(currentLanguage, {
    minimumFractionDigits: 2,
  });

  const suitableFeeDisclaimer = useMemo<TPayPageFeesDisclaimers | undefined>(() => {
    if (!paymentType) {
      return feesDisclaimers[0];
    }

    return feesDisclaimers.find(
      (feeDisclaimer) => feeDisclaimer.paymentType?.toLowerCase() === paymentType.toLowerCase(),
    );
  }, [feesDisclaimers, paymentType]);

  if (!suitableFeeDisclaimer) {
    return null;
  }

  return (
    <>
      {!!i18n.exists(suitableFeeDisclaimer.key, { ns: 'feesPayPage' }) && <div className='fee-info'>
        <p>{t(suitableFeeDisclaimer.key, mapPayPageFeeData(suitableFeeDisclaimer, feeNF))}</p>
      </div>}
    </>
  );
};
